module.exports = "/assets/data/bd11c6aef2c41af8a27b2c79104cd49a-CA9.data.json";